import React from 'react';
import ReactDOM from 'react-dom/client';
// ✅ CORRECT: Import from path alias
import { initFirebase } from '@canvas/firebase-config/client';
import App from './App';
import './index.css';
import './styles/pdfe.css';

// Initialize Firebase (production project canva-597cb)
initFirebase();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
